import React from "react";

interface NewTaskIconProps {
  className?: string;
}

export const NewTaskIcon = ({ className }: NewTaskIconProps) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="48" height="48" rx="24" fill="#0344DC" />
    <path
      d="M32.625 22.875C32.875 22.875 33 23 33 23.25V24.75C33 25 32.875 25.125 32.625 25.125H25.125V32.625C25.125 32.875 25 33 24.75 33H23.25C23 33 22.875 32.875 22.875 32.625V25.125H15.375C15.125 25.125 15 25 15 24.75V23.25C15 23 15.125 22.875 15.375 22.875H22.875V15.375C22.875 15.125 23 15 23.25 15H24.75C25 15 25.125 15.125 25.125 15.375V22.875H32.625Z"
      fill="white"
    />
  </svg>
);

NewTaskIcon.defaultProps = {
  className: "",
};
